import { initialBenefitsState, IBenefitsState } from "@edp-store/state/benefits.state";
import { EBenefitsActions, BenefitsActions } from "@edp-store/actions/benefits.actions";

export function benefitsReducers(state = initialBenefitsState, action: BenefitsActions): IBenefitsState {
    switch (action.type) {
        case EBenefitsActions.SetCards: {
            return {
                ...state,
                cards: action.payload,
            };
        }
        case EBenefitsActions.SetExclusiveBenefitsCards: {
            return {
                ...state,
                exclusiveBenefitsCards: action.payload,
            };
        }
        case EBenefitsActions.SetBenefitsUsersDetails: {
            return {
                ...state,
                benefitsUsers: action.payload,
            };
        }
        case EBenefitsActions.SetGeneratedCodeCards: {
            return {
                ...state,
                generatedCodeCards: action.payload,
            };
        }
        case EBenefitsActions.SetFilters: {
            return {
                ...state,
                filters: action.payload,
            };
        }
        case EBenefitsActions.SetCardTypes: {
            return {
                ...state,
                cardTypes: action.payload,
            };
        }
        case EBenefitsActions.SetLoadedCards: {
            return {
                ...state,
                loadedCards: action.payload,
            };
        }
        case EBenefitsActions.ReloadFilters: {
            return {
                ...state,
                reloadFilters: action.payload,
            };
        }
        case EBenefitsActions.SetErrorBenefits: {
            return {
                ...state,
                errorBenefits: action.payload,
            };
        }
        case EBenefitsActions.ActiveShareModal: {
            return {
                ...state,
                shareModal: action.payload,
            };
        }
        case EBenefitsActions.SetCounterGeneratedCodes: {
            return {
                ...state,
                counterPartnerBenefits: action.payload,
            };
        }
        case EBenefitsActions.SetCodeValidaty: {
            return {
                ...state,
                codeValidity: action.payload,
            };
        }
        case EBenefitsActions.SetTransactions: {
            return {
                ...state,
                transactions: action.payload,
            };
        }
        case EBenefitsActions.SetBalance: {
            return {
                ...state,
                balance: action.payload,
            };
        }
        case EBenefitsActions.SetBenefitUserSelected: {
            return {
                ...state,
                benefitUserSelected: action.payload,
            };
        }
        case EBenefitsActions.SetPageCounter: {
            return {
                ...state,
                benefitUserSelected: {
                    ...state.benefitUserSelected,
                    pageCounter: (Number(state.benefitUserSelected.pageCounter) + 1).toString(),
                },
            };
        }
        case EBenefitsActions.SetBenefitOnboarding: {
            return {
                ...state,
                benefitUserSelected: {
                    ...state.benefitUserSelected,
                    onboarding: false,
                },
            };
        }
        case EBenefitsActions.SetBenefitsDistricts: {
            return {
                ...state,
                districts: action.payload,
            };
        }
        case EBenefitsActions.SetAvailableOffersFilter: {
            return {
                ...state,
                availableOffersFilter: action.payload,
            };
        }
        default: {
            return state;
        }
    }
}
